import { createAction, props } from '@ngrx/store';
import { CompanyUserTodo } from '../../interfaces/company-user-todo';
import { Todo } from '../../interfaces/todo';

export const loadTodosLazy = createAction('[Todo/API] Load Todos Lazy');

export const loadTodosPolling = createAction('[Todo/API] Load Todos Polling');

export const loadTodosLazySuccess = createAction(
  '[Todo/API] Load Todos Lazy Success',
  props<{ todos: CompanyUserTodo[]; overall: number; undone: number }>()
);

export const loadTodosPollingSuccess = createAction(
  '[Todo/API] Load Todos Polling Success',
  props<{ todos: CompanyUserTodo[]; overall: number; undone: number }>()
);

export const loadTodosFailure = createAction('[Todo/API] Load Todos Failure', props<{ error: any }>());

export const toggleTodoState = createAction(
  '[Todo/API] Toggle Todo State',
  props<{ todo: CompanyUserTodo | Todo }>()
);

export const toggleTodoStateSuccess = createAction(
  '[Todo/API] Toggle Todo State Success',
  props<{ todo: CompanyUserTodo | Todo }>()
);

export const toggleTodoStateFailure = createAction('[Todo/API] Toggle Todo State Failure', props<{ error: any }>());

export const markAllTodosAsDone = createAction('[Todo/API] Mark all Todos as done');

export const markAllTodosAsDoneSuccess = createAction('[Todo/API] Mark all Todos as done Success');

export const markAllTodosAsDoneFailure = createAction(
  '[Todo/API] Mark all Todos as done Failure',
  props<{ error: any }>()
);

export const deleteTodo = createAction(
  '[Todo/API] Delete todo',
  props<{ todo: CompanyUserTodo | Todo }>()
);

export const deleteTodoSuccess = createAction(
  '[Todo/API] Delete todo Success',
  props<{ todo: CompanyUserTodo | Todo }>()
);

export const deleteTodoFailure = createAction('[Todo/API] Delete todo Failure', props<{ error: any }>());

export const deleteAllTodos = createAction('[Todo/API] Delete all todos');

export const deleteAllTodosSuccess = createAction('[Todo/API] Delete all todos Success');

export const deleteAllTodosFailure = createAction('[Todo/API] Delete all todos Failure', props<{ error: any }>());

export const clearTodos = createAction('[Todo/API] Clear Todos');
